// extracted by mini-css-extract-plugin
module.exports = {"title":"title-1el8j","list":"list-377-E","btn":"btn-qnhMw","btn_back":"btn_back-cbQV6","btn_read":"btn_read-1tqKv","empty":"empty-EJWOl"};